import React from 'react'
import { toast } from 'react-toastify'

function SystemUsersToggle({ params, setParams }) {
  const handleChange = () => {
    setParams({ ...params, showSystem: !params.showSystem })
    toast.info('Counts in the application may take a couple of minutes to reflect this change.')
  }

  return (
    <div className="form-check form-switch mt-1">
      <input
        className="form-check-input"
        type="checkbox"
        id="showSystem"
        checked={params.showSystem}
        onChange={handleChange}
      />
      <label className="form-check-label" htmlFor="showSystem">
        Show System Users
      </label>
    </div>
  )
}

export default SystemUsersToggle
